module.exports = __webpack_public_path__ + "static/media/QuestLogo.a69a9408.png";